import React, { useState, useEffect } from 'react';

export const AddQuestionsilllus = () => {
  const [primaryColor, setPrimaryColor] = useState('#ffd800');

  const storedTheme = JSON.parse(localStorage.getItem('themeSettings')) || '';

  useEffect(() => {
    if (storedTheme !== '') {
      setPrimaryColor(storedTheme?.primaryColor);
    }
  }, [storedTheme]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="200"
      viewBox="0 0 970 294.946"
    >
      <g
        id="Group_41194"
        data-name="Group 41194"
        transform="translate(-950 -834.616)"
      >
        <path
          id="Path_16457"
          data-name="Path 16457"
          d="M0,0,345.508,62.828,970,0V128a10,10,0,0,1-10,10H10A10,10,0,0,1,0,128Z"
          transform="translate(950 991.563)"
          fill="#ffd800"
          opacity="0.096"
        />
        <g
          id="Group_5268"
          data-name="Group 5268"
          transform="translate(738.738 463.662)"
        >
          <g
            id="Group_5244"
            data-name="Group 5244"
            transform="translate(281.186 449.909)"
          >
            <g
              id="Group_5243"
              data-name="Group 5243"
              transform="translate(0 29.771)"
            >
              <path
                id="Path_16459"
                data-name="Path 16459"
                d="M535.2,1049.837a41.614,41.614,0,0,0-22.062-21.553c-10.141-4.107-21.785-2.612-32.467-3.988-9.277-1.195-15.971-5.336-21.51-12.7-5.308-7.055-10.066-14.869-18.745-18.132-6.857-2.579-14.653-1.864-21.468.823-12.558,4.952-22.043,15.48-30.031,25.968-7.293,9.576-13.242,20.062-26.732,20.4s-26.35-7.358-39.941-5.318c-17.963,2.7-32.923,17.651-36.058,35.453-2.938,16.685,4.434,32.867,17.1,42.375h217.7C536.946,1096.241,545.32,1072.853,535.2,1049.837Z"
                transform="translate(-285.545 -991.86)"
                fill="#f7f0e3"
              />
              <g
                id="Group_5242"
                data-name="Group 5242"
                transform="translate(6.965 3.366)"
              >
                <path
                  id="Path_16460"
                  data-name="Path 16460"
                  d="M556.949,1317.881h.6a45.938,45.938,0,0,0,9.488-16.275,42.757,42.757,0,0,0-.4-29.45,84.879,84.879,0,0,0-7-12.923,82.963,82.963,0,0,1-7.066-13.1,29.219,29.219,0,0,1-1.636-6.054c-.15-.02-.3-.036-.451-.054a29.629,29.629,0,0,0,1.679,6.267,83.282,83.282,0,0,0,7.1,13.171,84.533,84.533,0,0,1,6.969,12.854,42.32,42.32,0,0,1,.389,29.148A45.432,45.432,0,0,1,556.949,1317.881Z"
                  transform="translate(-511.053 -1199.937)"
                  fill="#fff"
                />
                <path
                  id="Path_16461"
                  data-name="Path 16461"
                  d="M900.805,1110.043c4.485.956,8.808,1.813,12.988,2.352.072-.138.141-.277.212-.415-4.215-.536-8.578-1.4-13.109-2.365-6.9-1.47-14.367-3.061-21.773-3.061a38.646,38.646,0,0,0-13.536,2.236,27.616,27.616,0,0,0-4.79,2.329c-3.962-1.689-7.946-3.532-11.892-5.556,2.863-2.157,5.757-4.27,8.681-6.312,21.71-15.159,41.745-23.754,61.1-26.193-.039-.142-.079-.283-.12-.425-19.408,2.459-39.488,11.075-61.233,26.259-2.987,2.086-5.941,4.244-8.863,6.448a146.709,146.709,0,0,1-13.066-7.593,113.811,113.811,0,0,1-24.848-21.807c30.985-3.476,62.532-7.856,88.293-25.073.978-.654,2.062-1.425,3.185-2.3-.125-.089-.25-.175-.375-.262-1.076.833-2.113,1.569-3.053,2.2-25.755,17.213-57.36,21.56-88.385,25.035a85.152,85.152,0,0,1-14.207-24.155c-5.465-14.476-5.176-28.682.792-38.975.259-.447.533-.887.815-1.323-.249.114-.5.233-.743.352q-.23.373-.451.751c-6.034,10.408-6.334,24.75-.822,39.349a85.49,85.49,0,0,0,14.1,24.058q-2.694.3-5.383.6c-6.461.713-13.141,1.451-19.629,2.286-2.368.3-4.776.66-7.172,1.106-5.136-10.84-10.778-21.416-18.072-30.486-.1.1-.21.2-.316.307,7.231,9,12.838,19.5,17.943,30.262-10.45,1.993-20.6,5.74-26.017,14.461-5.06,8.144-5.056,19.4.014,33.46q.263.729.539,1.442h.469c-.2-.521-.4-1.047-.6-1.59-5.022-13.926-5.039-25.056-.053-33.081,5.354-8.617,15.446-12.314,25.838-14.283,1.813,3.836,3.565,7.7,5.306,11.546l.189.418c6.046,13.347,12.3,26.227,20.487,36.99h.546c-8.262-10.783-14.55-23.74-20.634-37.17l-.189-.418c-1.726-3.811-3.463-7.645-5.26-11.449,2.35-.434,4.711-.782,7.034-1.081,6.483-.834,13.162-1.572,19.62-2.285q2.829-.312,5.669-.628a114.1,114.1,0,0,0,25.129,22.115,146.942,146.942,0,0,0,12.919,7.52c-7.447,5.633-14.691,11.559-21.763,17.345q-3.673,3.005-7.423,6.051h.694q3.533-2.866,7.006-5.713c7.122-5.826,14.417-11.8,21.917-17.461,3.924,2.019,7.885,3.86,11.827,5.546a32.634,32.634,0,0,0-12.443,15.187c-.332.807-.623,1.622-.892,2.441h.461c.254-.762.526-1.521.836-2.274a32.133,32.133,0,0,1,12.529-15.145,289.2,289.2,0,0,0,31.149,10.908l.35.1a60.182,60.182,0,0,1,11.478,4.256c.1-.113.2-.226.3-.339a60.016,60.016,0,0,0-11.651-4.336l-.35-.1A289.8,289.8,0,0,1,861.3,1111.33a27.138,27.138,0,0,1,4.445-2.129C877.1,1104.992,889.693,1107.675,900.805,1110.043Z"
                  transform="translate(-673.38 -1011.084)"
                  fill="#fff"
                />
                <path
                  id="Path_16462"
                  data-name="Path 16462"
                  d="M337.194,1341.241a35.071,35.071,0,0,1-2.367,23.451,40.37,40.37,0,0,1-9.509,12.281c.08.124.161.247.242.37a40.818,40.818,0,0,0,9.66-12.458,35.514,35.514,0,0,0,2.4-23.748,30.142,30.142,0,0,0-8.853-15.4q-.142.167-.282.336A29.712,29.712,0,0,1,337.194,1341.241Z"
                  transform="translate(-325.318 -1270.639)"
                  fill="#fff"
                />
              </g>
            </g>
            <path
              id="Path_16463"
              data-name="Path 16463"
              d="M829.232,825.325a16.364,16.364,0,0,1,3.42,16.515,26.5,26.5,0,0,1-11.862,13.837c-4.314,2.511-9.942,3.9-14.186,1.267-3.171-1.965-4.815-5.82-4.907-9.549a24.821,24.821,0,0,1,2.713-10.757c2.185-4.783,5.126-9.421,9.506-12.33C819.955,820.3,825.566,821.579,829.232,825.325Z"
              transform="translate(-711.311 -821.845)"
              fill="#f7f0e3"
            />
          </g>
          <g
            id="Group_5245"
            data-name="Group 5245"
            transform="translate(296.432 370.954)"
          >
            <path
              id="Path_16464"
              data-name="Path 16464"
              d="M521.507,385.061H489.928V370.954h31.579Zm-30.922-.657H520.85V371.611H490.585Z"
              transform="translate(-469.384 -370.954)"
              fill="#e9ddca"
            />
            <path
              id="Path_16465"
              data-name="Path 16465"
              d="M404.186,462.1H372.607V448h31.579Zm-30.922-.657h30.266V448.654H373.264Z"
              transform="translate(-372.607 -434.506)"
              fill="#e9ddca"
            />
          </g>
          <g
            id="Group_5248"
            data-name="Group 5248"
            transform="translate(390.9 374.359)"
          >
            <g
              id="Group_5246"
              data-name="Group 5246"
              transform="translate(0 0)"
            >
              <path
                id="Path_16466"
                data-name="Path 16466"
                d="M1088.607,433.126a48.805,48.805,0,0,0-10.79-18.749q-7.738-8.56-21.108-14.145t-33.974-5.589a132.917,132.917,0,0,0-33.5,4.433,99.556,99.556,0,0,0-29.643,12.667l10.905,29.94-5.845,4.735,8.476,2.491A124.476,124.476,0,0,1,996,439.368a79.073,79.073,0,0,1,21.9-2.955q11.592,0,17.553,5.589a17.839,17.839,0,0,1,5.956,13.491,25.888,25.888,0,0,1-6.113,16.939q-6.134,7.4-13.537,14.969-5.143,5.252-9.982,10.847a77.868,77.868,0,0,0-8.535,12.014,65.321,65.321,0,0,0-5.956,13.813,56.7,56.7,0,0,0-2.254,16.607c0,1.981.042,4.337.157,7.078.019.506.046,1,.076,1.485h-8.013L996,555.159h42.519a28.237,28.237,0,0,1-.325-4.6V546.6a28.562,28.562,0,0,1,2.255-11.018,56.982,56.982,0,0,1,5.641-10.365,76.555,76.555,0,0,1,7.57-9.369q4.184-4.449,8.053-8.395,5.143-5.252,10.622-11.179a87.87,87.87,0,0,0,9.668-12.5,70.194,70.194,0,0,0,6.921-14.316,50.393,50.393,0,0,0,2.747-16.939A67.744,67.744,0,0,0,1088.607,433.126Z"
                transform="translate(-951.274 -393.9)"
                fill={primaryColor}
              />
              <path
                id="Path_16467"
                data-name="Path 16467"
                d="M969.718,430.823a79.688,79.688,0,0,0-21.647,2.86,124.484,124.484,0,0,0-22.6,9.233l-13.378-35.969a99.482,99.482,0,0,1,29.3-12.259A133.974,133.974,0,0,1,974.5,390.4q20.362,0,33.575,5.409t20.86,13.689a47,47,0,0,1,10.663,18.145,64.31,64.31,0,0,1,3.026,18.777,47.859,47.859,0,0,1-2.715,16.394,67.368,67.368,0,0,1-6.839,13.855,85.307,85.307,0,0,1-9.554,12.093q-5.409,5.736-10.5,10.819-3.824,3.824-7.958,8.124a74.4,74.4,0,0,0-7.482,9.067A54.8,54.8,0,0,0,992,526.8a27.146,27.146,0,0,0-2.228,10.663v3.824a26.786,26.786,0,0,0,.321,4.456h-42.02a44.551,44.551,0,0,1-.8-7.16c-.114-2.653-.155-4.933-.155-6.85a53.8,53.8,0,0,1,2.228-16.072,62.539,62.539,0,0,1,5.886-13.368,75.376,75.376,0,0,1,8.435-11.627q4.772-5.409,9.865-10.5,7.321-7.321,13.378-14.487a24.742,24.742,0,0,0,6.041-16.394,17.1,17.1,0,0,0-5.886-13.057Q981.174,430.823,969.718,430.823Z"
                transform="translate(-912.092 -390.399)"
                fill={primaryColor}
              />
            </g>
            <g
              id="Group_5247"
              data-name="Group 5247"
              transform="translate(33.273 178.514)"
            >
              <path
                id="Path_16468"
                data-name="Path 16468"
                d="M1198.17,1435.156q0,11.5-7.445,17.754a25.77,25.77,0,0,1-33.68,0q-7.432-6.259-7.436-17.754t7.437-17.754a25.873,25.873,0,0,1,27.888-3.359A23.908,23.908,0,0,1,1198.17,1435.156Z"
                transform="translate(-1141.29 -1411.139)"
                fill={primaryColor}
              />
              <path
                id="Path_16469"
                data-name="Path 16469"
                d="M1150.67,1433.865q0,11.5-7.445,17.754a25.771,25.771,0,0,1-33.681,0q-7.432-6.259-7.436-17.754t7.436-17.754a25.771,25.771,0,0,1,33.681,0Q1150.67,1422.384,1150.67,1433.865Z"
                transform="translate(-1102.108 -1409.848)"
                fill={primaryColor}
              />
            </g>
          </g>
          <g
            id="Group_5267"
            data-name="Group 5267"
            transform="translate(294.463 418.818)"
          >
            <g
              id="Group_5251"
              data-name="Group 5251"
              transform="translate(11.098 0)"
            >
              <circle
                id="Ellipse_71"
                data-name="Ellipse 71"
                cx="4.579"
                cy="4.579"
                r="4.579"
                transform="matrix(0.184, -0.983, 0.983, 0.184, 31.453, 52.21)"
                fill="#d9d9d9"
              />
              <ellipse
                id="Ellipse_72"
                data-name="Ellipse 72"
                cx="2.575"
                cy="2.594"
                rx="2.575"
                ry="2.594"
                transform="translate(37.912 59.574) rotate(-79.386)"
                fill="#d9d9d9"
              />
              <g
                id="Group_5250"
                data-name="Group 5250"
                transform="translate(0)"
              >
                <circle
                  id="Ellipse_73"
                  data-name="Ellipse 73"
                  cx="18.029"
                  cy="18.029"
                  r="18.029"
                  transform="translate(0 25.497) rotate(-45)"
                  fill="#d8d8d8"
                />
                <g
                  id="Group_5249"
                  data-name="Group 5249"
                  transform="translate(16.303 23.226)"
                >
                  <circle
                    id="Ellipse_74"
                    data-name="Ellipse 74"
                    cx="2.272"
                    cy="2.272"
                    r="2.272"
                    fill="#fff"
                  />
                  <circle
                    id="Ellipse_75"
                    data-name="Ellipse 75"
                    cx="2.272"
                    cy="2.272"
                    r="2.272"
                    transform="translate(6.923)"
                    fill="#fff"
                  />
                  <circle
                    id="Ellipse_76"
                    data-name="Ellipse 76"
                    cx="2.272"
                    cy="2.272"
                    r="2.272"
                    transform="translate(13.846)"
                    fill="#fff"
                  />
                </g>
              </g>
            </g>
            <g
              id="Group_5266"
              data-name="Group 5266"
              transform="translate(0 64.902)"
            >
              <g
                id="Group_5254"
                data-name="Group 5254"
                transform="translate(10.559 71.719)"
              >
                <g
                  id="Group_5252"
                  data-name="Group 5252"
                  transform="translate(13.01 29.53)"
                >
                  <path
                    id="Path_16470"
                    data-name="Path 16470"
                    d="M496.072,1600.051l1.685,6.494a3.721,3.721,0,0,0,3.888,2.715c5.523-.375,17-1.728,23.586-6.583l-1.872-9.36c-9.056-.511-17.526-.008-24.859,2.461A3.587,3.587,0,0,0,496.072,1600.051Z"
                    transform="translate(-495.961 -1593.136)"
                    fill="#102048"
                  />
                  <path
                    id="Path_16471"
                    data-name="Path 16471"
                    d="M545.189,1621.93a.219.219,0,0,1-.211-.16l-2.262-8.1a.219.219,0,0,1,.422-.118l2.262,8.1a.219.219,0,0,1-.152.27A.224.224,0,0,1,545.189,1621.93Z"
                    transform="translate(-534.522 -1609.846)"
                    fill="#fff"
                  />
                  <path
                    id="Path_16472"
                    data-name="Path 16472"
                    d="M573.105,1615.679a.219.219,0,0,1-.211-.16l-2.262-8.1a.219.219,0,0,1,.422-.118l2.262,8.1a.219.219,0,0,1-.152.27A.226.226,0,0,1,573.105,1615.679Z"
                    transform="translate(-557.55 -1604.69)"
                    fill="#fff"
                  />
                </g>
                <path
                  id="Path_16473"
                  data-name="Path 16473"
                  d="M518.059,1425.837l-21.049,6.247,15.632,21.418,22.442,1.785,30.954-13.089-11.762-17.7Z"
                  transform="translate(-483.817 -1424.498)"
                  fill={primaryColor}
                />
                <path
                  id="Path_16474"
                  data-name="Path 16474"
                  d="M646.809,1436.025c46.224-13.684,53.653,27.169-18.469,34.606a34.89,34.89,0,0,1-6.707-12l38.087-17.6Z"
                  transform="translate(-586.617 -1431.712)"
                  fill={primaryColor}
                />
                <path
                  id="Path_16475"
                  data-name="Path 16475"
                  d="M721.679,1606.631a19.988,19.988,0,0,1-4.233-2.06l-7.429,2.33,1.7,8.081,7.717,1.568A16.59,16.59,0,0,0,721.679,1606.631Z"
                  transform="translate(-659.524 -1573.039)"
                  fill="#f9b384"
                />
                <path
                  id="Path_16476"
                  data-name="Path 16476"
                  d="M621.021,1487.761l-.33-.568c7.946-4.618,28.3-15.711,45.638-18.983l.122.646C649.211,1472.108,628.937,1483.16,621.021,1487.761Z"
                  transform="translate(-585.84 -1460.556)"
                  fill="#e49b31"
                />
                <path
                  id="Path_16477"
                  data-name="Path 16477"
                  d="M455.908,1427.121c-43.026-8.181-54.169,33.168,17.953,40.605a26.2,26.2,0,0,0,5.726-10.412,328.378,328.378,0,0,0-37.041-21.17Z"
                  transform="translate(-421.667 -1425.782)"
                  fill={primaryColor}
                />
                <path
                  id="Path_16478"
                  data-name="Path 16478"
                  d="M555.786,1488c-2.047-1.3-4.179-2.68-6.437-4.138-11.334-7.318-24.181-15.612-35.1-20.342l.261-.6c10.964,4.751,23.835,13.061,35.19,20.393,2.257,1.457,4.389,2.834,6.434,4.135Z"
                  transform="translate(-498.041 -1456.188)"
                  fill="#e49b31"
                />
                <path
                  id="Path_16479"
                  data-name="Path 16479"
                  d="M434.23,1520.117l-.575-.318a12.072,12.072,0,0,1,7.689-5.861l.175.633A11.294,11.294,0,0,0,434.23,1520.117Z"
                  transform="translate(-431.556 -1498.276)"
                  fill="#e49b31"
                />
                <path
                  id="Path_16480"
                  data-name="Path 16480"
                  d="M915.433,1505.9a11.3,11.3,0,0,0-7.289-5.546l.175-.633a12.073,12.073,0,0,1,7.689,5.861Z"
                  transform="translate(-822.958 -1486.55)"
                  fill="#e49b31"
                />
                <path
                  id="Path_16481"
                  data-name="Path 16481"
                  d="M694.47,1603.8l-.48-.448a24.6,24.6,0,0,0,6.462-11.9l.643.135A25.229,25.229,0,0,1,694.47,1603.8Z"
                  transform="translate(-646.304 -1562.222)"
                  fill="#e49b31"
                />
                <g
                  id="Group_5253"
                  data-name="Group 5253"
                  transform="translate(59.913 30.128)"
                >
                  <path
                    id="Path_16482"
                    data-name="Path 16482"
                    d="M787.513,1597.608c-5.513-3.406-16.2,2.479-18.882,2.776a6.456,6.456,0,0,1-2.576-.37,16.59,16.59,0,0,1-2.242,9.92l1.311.266a38.593,38.593,0,0,0,18.675,1.388C792.672,1609.8,791.846,1600.285,787.513,1597.608Z"
                    transform="translate(-763.812 -1596.551)"
                    fill="#102048"
                  />
                  <path
                    id="Path_16483"
                    data-name="Path 16483"
                    d="M850.579,1621.351a.222.222,0,0,1-.066-.01.219.219,0,0,1-.143-.275c.655-2.074.941-6.153-.956-8.893a.219.219,0,0,1,.36-.249c1.986,2.869,1.695,7.119,1.014,9.274A.219.219,0,0,1,850.579,1621.351Z"
                    transform="translate(-834.392 -1609.154)"
                    fill="#fff"
                  />
                  <path
                    id="Path_16484"
                    data-name="Path 16484"
                    d="M825.891,1626.039a.219.219,0,0,1-.209-.285c.655-2.074.94-6.153-.956-8.893a.219.219,0,0,1,.36-.249c1.986,2.869,1.695,7.118,1.014,9.274A.219.219,0,0,1,825.891,1626.039Z"
                    transform="translate(-814.028 -1613.021)"
                    fill="#fff"
                  />
                </g>
              </g>
              <g id="Group_5262" data-name="Group 5262">
                <g
                  id="Group_5256"
                  data-name="Group 5256"
                  transform="translate(24.394 0.386)"
                >
                  <path
                    id="Path_16485"
                    data-name="Path 16485"
                    d="M513.467,1036.494s10.836-9.214,10.435-10.965c-.287-1.251-3.356.584-3.356.584s4.3-5.107,4.086-5.728c-.391-1.108-3.368.958-3.368.958s2.012-2.9,1.05-3.368-3.059,1.313-3.059,1.313,1.225-1.608.65-2.03-3.059,1.313-3.059,1.313.891-2.028-1-1.259-15.17,12.953-15.17,12.953Z"
                    transform="translate(-500.671 -1017.136)"
                    fill="#f9b384"
                  />
                  <g
                    id="Group_5255"
                    data-name="Group 5255"
                    transform="translate(12.195 1.214)"
                  >
                    <path
                      id="Path_16486"
                      data-name="Path 16486"
                      d="M575.347,1050.058a.219.219,0,0,1-.148-.057,9.942,9.942,0,0,0-4.732-2.743.219.219,0,1,1,.129-.418,10.289,10.289,0,0,1,4.9,2.839.219.219,0,0,1-.148.38Z"
                      transform="translate(-570.312 -1042.844)"
                      fill="#e28b6d"
                    />
                    <path
                      id="Path_16487"
                      data-name="Path 16487"
                      d="M579.386,1077.731l-.031,0a.219.219,0,0,1-.186-.247c.213-1.524.693-2.476,1.466-2.911a2.84,2.84,0,0,1,2.558.113.219.219,0,0,1-.174.4,2.443,2.443,0,0,0-2.17-.134,3.344,3.344,0,0,0-1.247,2.59A.219.219,0,0,1,579.386,1077.731Z"
                      transform="translate(-577.616 -1065.519)"
                      fill="#e28b6d"
                    />
                    <path
                      id="Path_16488"
                      data-name="Path 16488"
                      d="M576.469,1027.07a.219.219,0,0,1-.15-.378l2.719-2.563a.219.219,0,1,1,.3.318l-2.719,2.563A.217.217,0,0,1,576.469,1027.07Z"
                      transform="translate(-575.21 -1024.07)"
                      fill="#e28b6d"
                    />
                    <path
                      id="Path_16489"
                      data-name="Path 16489"
                      d="M590.844,1031.323a.219.219,0,0,1-.158-.37l2.612-2.721a.219.219,0,0,1,.316.3L591,1031.256A.218.218,0,0,1,590.844,1031.323Z"
                      transform="translate(-587.068 -1027.447)"
                      fill="#e28b6d"
                    />
                    <path
                      id="Path_16490"
                      data-name="Path 16490"
                      d="M605.531,1042.539a.219.219,0,0,1-.16-.368l2.049-2.2a.219.219,0,1,1,.32.3l-2.049,2.2A.219.219,0,0,1,605.531,1042.539Z"
                      transform="translate(-599.183 -1037.131)"
                      fill="#e28b6d"
                    />
                  </g>
                </g>
                <g
                  id="Group_5257"
                  data-name="Group 5257"
                  transform="translate(0 11.087)"
                >
                  <path
                    id="Path_16491"
                    data-name="Path 16491"
                    d="M600.246,1233.553l-39.618,1.532-4.378-36.116s13.263-12.58,18.366-17.213l8.614-.442C609.958,1193.464,605.581,1208.637,600.246,1233.553Z"
                    transform="translate(-522.124 -1163.266)"
                    fill="#3b4046"
                  />
                  <path
                    id="Path_16492"
                    data-name="Path 16492"
                    d="M710.329,1181.315s30.578,2.615,40.217,23.565c9.432,20.5-29.331,27.8-29.331,27.8Z"
                    transform="translate(-649.222 -1163.266)"
                    fill="#3b4046"
                  />
                  <path
                    id="Path_16493"
                    data-name="Path 16493"
                    d="M387.519,1100.783l12.636-15.377-11.816-7.161a154.088,154.088,0,0,0-22.538,19.98,16.683,16.683,0,0,0-3.877,6.7,14.422,14.422,0,0,0-.371,6.292h0a12.148,12.148,0,0,0,10.736,10.17c4.814.564,23.2-.875,38.086-5.253l4.378-16.9C412.5,1097.964,395.784,1097.743,387.519,1100.783Z"
                    transform="translate(-361.364 -1078.245)"
                    fill="#3b4046"
                  />
                </g>
                <g
                  id="Group_5258"
                  data-name="Group 5258"
                  transform="translate(6.458 16.173)"
                  opacity="0.8"
                >
                  <path
                    id="Path_16494"
                    data-name="Path 16494"
                    d="M785.531,1200.375l.2-.045c-.138-.082-.277-.161-.415-.241a66.306,66.306,0,0,1-6.832,1.318c-1.37.165-5.946.467-7.283-2.582a4.777,4.777,0,0,1,.591-4.388l-.328-.094a5.068,5.068,0,0,0-.563,4.614c1.428,3.257,6.2,2.948,7.623,2.776A67.632,67.632,0,0,0,785.531,1200.375Z"
                    transform="translate(-705.364 -1179.099)"
                    fill="#fff"
                  />
                  <path
                    id="Path_16495"
                    data-name="Path 16495"
                    d="M891.038,1358.91a10.151,10.151,0,0,0-4.557-1c-2.783.263-5.164,3.015-5.309,6.134a9.622,9.622,0,0,0,2.263,6.317l.279-.176a9.307,9.307,0,0,1-2.214-6.125c.137-2.963,2.385-5.575,5.012-5.823a9.8,9.8,0,0,1,4.407.978c.532.205,1.073.413,1.623.589.028-.106.056-.212.081-.319C892.088,1359.314,891.559,1359.112,891.038,1358.91Z"
                    transform="translate(-796.601 -1314.006)"
                    fill="#fff"
                  />
                  <path
                    id="Path_16496"
                    data-name="Path 16496"
                    d="M424.958,1296.636c-1.909-1.579-4.875-2-8.137-1.158a14.041,14.041,0,0,0-7.114,4.212c.113.036.223.077.337.111a13.771,13.771,0,0,1,6.859-4c3.158-.817,6.018-.418,7.846,1.093a7.128,7.128,0,0,1,1.929,2.657l.339-.039A7.505,7.505,0,0,0,424.958,1296.636Z"
                    transform="translate(-407.7 -1262.173)"
                    fill="#fff"
                  />
                  <path
                    id="Path_16497"
                    data-name="Path 16497"
                    d="M398.243,1120.036a39.609,39.609,0,0,0,10.287-3.992,11.238,11.238,0,0,0,3.556-2.906,4.991,4.991,0,0,0,.914-4.445,3.475,3.475,0,0,0-.891-1.4l-.253.207a3.167,3.167,0,0,1,.831,1.3,4.664,4.664,0,0,1-.866,4.147,10.941,10.941,0,0,1-3.456,2.816,38.8,38.8,0,0,1-9.7,3.833Z"
                    transform="translate(-398.243 -1107.289)"
                    fill="#fff"
                  />
                </g>
                <g
                  id="Group_5260"
                  data-name="Group 5260"
                  transform="translate(39.301)"
                >
                  <path
                    id="Path_16498"
                    data-name="Path 16498"
                    d="M674.229,1132.846l-.006.561-.089,8.708-.011.943a5.423,5.423,0,0,1-10.845-.005l-.105-10.762Z"
                    transform="translate(-649.624 -1111.74)"
                    fill="#f9b384"
                  />
                  <path
                    id="Path_16499"
                    data-name="Path 16499"
                    d="M693.675,1138.662l-.089,8.708c-4.84-1.97-6.832-7.21-6.832-7.21Z"
                    transform="translate(-669.076 -1116.996)"
                    fill="#102048"
                  />
                  <path
                    id="Path_16500"
                    data-name="Path 16500"
                    d="M670.869,1048.285c1.734,2.081,6.8,13.875,1.665,17.9-5.777,4.528-14.569-2.914-14.569-2.914l-1.179-13.737,7.631-2.012Z"
                    transform="translate(-644.356 -1041.815)"
                    fill="#f9b384"
                  />
                  <path
                    id="Path_16501"
                    data-name="Path 16501"
                    d="M594.343,1047.559s-16.927,8.828-3.125,34.277a6.932,6.932,0,0,0,9.058,3.1h0a6.866,6.866,0,0,0,3.011-9.589c-2.258-4.011-4.437-9.175-3.507-13.018Z"
                    transform="translate(-585.801 -1041.845)"
                    fill="#102048"
                  />
                  <circle
                    id="Ellipse_77"
                    data-name="Ellipse 77"
                    cx="4.579"
                    cy="4.579"
                    r="4.579"
                    transform="translate(3.665 9.893) rotate(-45)"
                    fill={primaryColor}
                  />
                  <path
                    id="Path_16502"
                    data-name="Path 16502"
                    d="M636.025,1030.325c-.495-2.857-.8-4.816,2.091-6.288,0,0,10.175,1.85,12.118-1.989s-1.018-9.9-7.215-5.689c-15.864-3.1-17.992,11.748-13.182,16.7l4.747-.729A1.728,1.728,0,0,0,636.025,1030.325Z"
                    transform="translate(-620.252 -1014.931)"
                    fill="#102048"
                  />
                  <g
                    id="Group_5259"
                    data-name="Group 5259"
                    transform="translate(20.472 10.183)"
                  >
                    <circle
                      id="Ellipse_78"
                      data-name="Ellipse 78"
                      cx="0.676"
                      cy="0.676"
                      r="0.676"
                      transform="translate(2.504 4.543)"
                      fill="#102048"
                    />
                    <circle
                      id="Ellipse_79"
                      data-name="Ellipse 79"
                      cx="0.676"
                      cy="0.676"
                      r="0.676"
                      transform="translate(7.082 2.288)"
                      fill="#102048"
                    />
                    <path
                      id="Path_16503"
                      data-name="Path 16503"
                      d="M737.4,1100.065a.191.191,0,0,1-.139-.323c.271-.286.568-.687.444-.978s-.678-.433-.929-.433c-.54,0-.8-.96-.845-1.152a.192.192,0,0,1,.372-.09c.1.406.322.86.473.86.258,0,1.048.122,1.281.665.166.387-.008.856-.518,1.393A.191.191,0,0,1,737.4,1100.065Z"
                      transform="translate(-730.106 -1092.764)"
                      fill="#102048"
                    />
                    <path
                      id="Path_16504"
                      data-name="Path 16504"
                      d="M730.568,1125.474a.19.19,0,0,1-.107-.033,2.56,2.56,0,0,0-2.573-.131.192.192,0,0,1-.191-.332,2.911,2.911,0,0,1,2.978.146.191.191,0,0,1-.107.35Z"
                      transform="translate(-723.243 -1115.606)"
                      fill="#102048"
                    />
                    <path
                      id="Path_16505"
                      data-name="Path 16505"
                      d="M705.594,1084.668c.385.724-.286.87-1.072,1.287s-1.59.57-1.773.225.3-.964,1.09-1.381S705.3,1084.107,705.594,1084.668Z"
                      transform="translate(-702.71 -1082.379)"
                      fill="#102048"
                    />
                    <path
                      id="Path_16506"
                      data-name="Path 16506"
                      d="M735.45,1074.067c.169.646.651.363,1.353.18s1.268-.536,1.187-.844-.715-.41-1.416-.226S735.32,1073.567,735.45,1074.067Z"
                      transform="translate(-729.701 -1073.085)"
                      fill="#102048"
                    />
                  </g>
                  <circle
                    id="Ellipse_80"
                    data-name="Ellipse 80"
                    cx="1.995"
                    cy="1.995"
                    r="1.995"
                    transform="matrix(0.735, -0.678, 0.678, 0.735, 17.711, 18.445)"
                    fill="#eb5d60"
                    opacity="0.4"
                  />
                  <ellipse
                    id="Ellipse_81"
                    data-name="Ellipse 81"
                    cx="2.701"
                    cy="3.07"
                    rx="2.701"
                    ry="3.07"
                    transform="matrix(0.611, -0.792, 0.792, 0.611, 8.875, 18.829)"
                    fill="#f9b384"
                  />
                  <path
                    id="Path_16507"
                    data-name="Path 16507"
                    d="M655.015,1116.179a.192.192,0,0,1-.192-.192,1.679,1.679,0,0,0-.737-1.4,1.352,1.352,0,0,0-1.259-.167.192.192,0,0,1-.145-.355,1.733,1.733,0,0,1,1.617.2,2.06,2.06,0,0,1,.907,1.716A.191.191,0,0,1,655.015,1116.179Z"
                    transform="translate(-640.873 -1096.611)"
                    fill="#102048"
                  />
                </g>
                <g
                  id="Group_5261"
                  data-name="Group 5261"
                  transform="translate(19.082 33.476)"
                >
                  <rect
                    id="Rectangle_2834"
                    data-name="Rectangle 2834"
                    width="10.182"
                    height="0.438"
                    transform="translate(0 7.476) rotate(-47.248)"
                    fill="#102048"
                  />
                  <path
                    id="Path_16508"
                    data-name="Path 16508"
                    d="M787.264,1345.683l-.128-.419c5.031-1.533,9.914-3.368,14.339-8.9l.342.273C797.314,1342.267,792.363,1344.128,787.264,1345.683Z"
                    transform="translate(-731.661 -1313.552)"
                    fill="#102048"
                  />
                </g>
              </g>
              <g
                id="Group_5265"
                data-name="Group 5265"
                transform="translate(32.156 48.653)"
              >
                <g id="Group_5263" data-name="Group 5263">
                  <path
                    id="Path_16509"
                    data-name="Path 16509"
                    d="M590.587,1292.776h-42.8a2.908,2.908,0,0,0-2.787,3.015v30.558a2.908,2.908,0,0,0,2.787,3.015h42.8a2.908,2.908,0,0,0,2.787-3.015v-30.558A2.908,2.908,0,0,0,590.587,1292.776Z"
                    transform="translate(-545 -1292.776)"
                    fill="#d3dfff"
                  />
                </g>
                <g
                  id="Group_5264"
                  data-name="Group 5264"
                  transform="translate(20.758 15.487)"
                >
                  <path
                    id="Path_16510"
                    data-name="Path 16510"
                    d="M669.231,1382.094a.307.307,0,0,1,.294.318v3.226a.307.307,0,0,1-.294.318h-4.519a.307.307,0,0,1-.294-.318v-3.226a.307.307,0,0,1,.294-.318h4.519m0-.876h-4.519a1.183,1.183,0,0,0-1.17,1.194v3.226a1.183,1.183,0,0,0,1.17,1.194h4.519a1.183,1.183,0,0,0,1.17-1.194v-3.226a1.183,1.183,0,0,0-1.17-1.194Z"
                    transform="translate(-663.542 -1381.218)"
                    fill="#1f3c88"
                  />
                </g>
              </g>
            </g>
          </g>
          <rect
            id="Rectangle_2835"
            data-name="Rectangle 2835"
            width="258.053"
            height="0.876"
            transform="translate(280.261 600.553)"
            fill="#102048"
          />
        </g>
      </g>
    </svg>
  );
};
